import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { AnchorDirective, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { BehaviorDataService } from '../../service/behaviorData.service';
import { DepositService } from '../../service/deposit.service';
import { GtmService } from '../../service/gtm.service';

@Component({
    selector: 'app-od-popup',
    imports: [CommonModule, TranslateModule, AnchorDirective],
    templateUrl: './od-popup.component.html',
})
export class OdPopupComponent implements OnInit {
    private navigationService = inject(NavigationService);
    constructor(
        public depositService: DepositService,
        private behaviorData: BehaviorDataService,
        private GTMService: GtmService,
    ) {}
    ngOnInit(): void {
        this.GTMService.raiseEventForODbannerLoad('complete your profile interceptor-under 2k');
    }
    close(btnName: any) {
        this.GTMService.raiseEventForODbannerClicks('close', 'complete your profile interceptor-under 2k', btnName, 'not applicable');
        this.depositService.showODpopUp.set(false);
    }
    redirectToODpage() {
        const url = this.behaviorData.userODetails?.urlInfo?.url;
        this.GTMService.raiseEventForODbannerClicks('click', 'complete your profile interceptor-under 2k', 'share details', url);
        this.navigationService.goTo(url, { forceReloadTarget: 'top' });
    }
}
